import React from "react";
import Header from "../basic/Header";
import RegistrationForm from "../registration-form/RegistrationForm";

class JoinUs extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};

    }

    render() {
        return (
            <div>
                <Header title={"Join Us"} subTitleText={"Create your profile, join us to explore more in detail on what you can get and enjoy this exciting journey of yours!"}/>
                <RegistrationForm />
            </div>
        );
    }
}

JoinUs.propTypes = {};

export default JoinUs;
